<template>
  <div v-if="flag.checked">
    <div>
      <!-- 登録がない場合 -->
      <div v-if="!customerDefaultSource">
        <CardRegist
          v-on:registed="toNext()"
          v-on:sendFlag="receiveCardRegistFlag"
          :hideBtn="true"
          :plan="coursename"
          ref="cardRegist"/>
      </div>

      <Spacer :y="3"/>

      <!-- 選択中のカード -->
      <div v-if="!flag.editCard && customerDefaultSource">
        <div :class="s.credit_card_wrap">
          <div :class="s.credit_card" v-if="customerDefaultSource?.id">
            <div
              :class="s.card_img"
              v-bind:style="{ 'background-image':`url('/img/cards/${getCardIconName(customerDefaultSource.brand)}.png')`}"></div>
            <p>**** **** **** {{ customerDefaultSource.last4 }}</p>
            <div v-if="customerDefaultSource.isCertified" :class="[s.certLabel, s.certified]"><i class="fa-regular fa-circle-check me-1"></i>認証済み</div>
            <div v-else :class="[s.certLabel, s.uncertified]"><i class="fa-regular fa-circle-exclamation me-1"></i>未認証</div>
          </div>
          <Spacer :x="6"/>
          <div
          :class="s.edit_btn"
          @click="updateEditFlag">変更する</div>
        </div>
      </div>
      <div
        class="mt-1"
        v-if="customerDefaultSource?.id && !customerDefaultSource.isCertified && !flag.editCard"
        :class="s.warning">カード情報の横のラベルが「未認証」となっている場合は、今後決済が失敗する可能性があります。<br>カード情報を新規登録し、認証する必要があります。</div>

      <!-- カード選択 -->
      <div v-if="flag.editCard">
        <CardSelect
          :hideBtn="true"
          v-on:updateEditFlag="updateEditFlag"
          v-on:updatedDefaultCard="toNext()"
          :plan="coursename"
          ref="cardSelect" />
        <div :class="s.btns">
          <button
            :class="[s.btn, s.secondary]"
            @click="updateEditFlag">キャンセル</button>
          <Spacer :x="2"/>
          <button
            :class="[s.btn, s.primary]"
            @click="updateCard">このカードに設定</button>
        </div>
      </div>

      <Spacer :y="6"/>

      <div :class="s.btns" v-if="!flag.editCard">
        <button
          :class="[s.btn, s.secondary]"
          @click="toBack('back')">戻る</button>
        <Spacer :x="2"/>
        <button
          v-if="!user?.subscribe?.cards.cards[0]"
          :class="[
            s.btn,
            s.primary,
            !flag.readySubmitRegist ? s.disabled : '',
          ]"
          :disabled="!flag.readySubmitRegist"
          @click="registCard">次に進む</button>
        <button
          :class="[ s.btn, s.primary ]"
          v-if="customerDefaultSource"
          @click="toNext()">次に進む</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { loadStripe } from '@stripe/stripe-js';
import cf from '@/mixins/commonFunctions.js';
import CardRegist from '@/components/parts/CardRegist.vue';
import CardSelect from '@/components/parts/CardSelect.vue';
import Spacer from '@/components/Spacer';

// stripe
const STRIPE_PUB_KEY = process.env.NODE_ENV === 'production'
  ? process.env.VUE_APP_STRIPE_PUBLIC_KEY_PROD
  : process.env.VUE_APP_STRIPE_PUBLIC_KEY_DEV;
const stripePromise = loadStripe(STRIPE_PUB_KEY);

export default {
  name: 'edit-subscription-payment-method',
  mixins: [cf],
  components: {
    CardRegist,
    CardSelect,
    Spacer,
  },
  props: {
    selectedCourse: String,
    customerDefaultSource: Object || null,
  },
  data() {
    return {
      flag: {
        checked: false,
        readySubmitRegist: false,
        editCard: false,
      },
      message: {
        cardError: '',
      },
    };
  },
  async mounted() {
    // カード3D認証からリダイレクト時
    if (this.$route.query.setup_intent && this.$route.query.setup_intent_client_secret) {
      const subscriptionLs = cf.getLocalStorage('times');
      const clientSecret = subscriptionLs?.subscription?.clientSecret;
      const plan = subscriptionLs?.subscription?.plan;

      if (clientSecret === this.$route.query.setup_intent_client_secret && plan) {
        this.$emit('changeCourse', plan);
        // redirect時はここでデフォルトカード変更処理(一番最新のカードにする)
        await this.handleSetupIntentRedirect();
      }

      this.$router.replace({ query: {} });
      cf.deleteLocalStorage('times', 'subscription');
    }

    if (!this.selectedCourse) this.$router.push('/edit/subscription/');
    else this.flag.checked = true;
  },
  computed: {
    ...mapState(['user', 'helper']),
  },
  methods: {
    toBack() {
      this.$router.push('/edit/subscription/cancel-exists/');
    },
    toNext() {
      if (this.selectedCourse.toLowerCase().includes('paper')) this.$router.push('/edit/subscription/delivery-address/');
      else this.$router.push('/edit/subscription/confirm/');
    },
    updateEditFlag() {
      this.flag.editCard = !this.flag.editCard;
    },
    async createCustomer() {
      const customerData = {
        email: this.user.email,
        name: !this.user.last_name && !this.user.first_name ? '名前未設定' : `${this.user.last_name} ${this.user.first_name}`,
        metadata: { user_id: this.user.id },
        preferred_locales: ['ja'],
      };
      try {
        const result = await this.axios({
          method: 'POST',
          url: '/v1/stripe/customer/set/register',
          data: {
            customerData,
          },
        });
        return result;
      } finally {
        this.hideLoading();
      }
    },
    async attachPaymentMethod(customerId, pmId) {
      try {
        const result = await this.axios({
          method: 'POST',
          url: '/v1/stripe/customer/attach/paymentMethod',
          data: {
            customer_id: customerId,
            payment_method_id: pmId,
          },
        });
        return result;
      // } catch (error) {
      //   throw error;
      } finally {
        this.hideLoading();
      }
    },

    updateCard() {
      this.$refs.cardSelect.updateDefaultCard();
    },
    receiveCardRegistFlag(flag) {
      this.flag.readySubmitRegist = flag;
    },
    registCard() {
      this.$refs.cardRegist.getConfirmCardsSetup();
    },
    async handleSetupIntentRedirect() {
      if (this.$route.query.redirect_status !== 'succeeded') {
        alert('支払い方法の認証中にエラーが発生しました。\n再度お試しいただくか、別の支払い方法を登録してください。');
        return;
      }

      const { setup_intent_client_secret: setupIntentClientSecret } = this.$route.query;
      if (!setupIntentClientSecret) return;

      try {
        this.showLoading();
        const stripe = await stripePromise;
        const { setupIntent, error } = await stripe.retrieveSetupIntent(setupIntentClientSecret);

        if (error) {
          alert('支払い方法の認証中にエラーが発生しました。\n再度お試しいただくか、別の支払い方法を登録してください。');
          console.error('Failed to retrieve SetupIntent:', error);
          return;
        }

        const paymentMethodId = setupIntent.payment_method;

        let customerId = this.user.customer?.customer_id;
        // 顧客情報がない場合は作成
        if (!customerId) {
          const createCustomerResult = await this.createCustomer();
          customerId = createCustomerResult.data.customer.id;
          if (!customerId) {
            alert('お客様情報の登録中にエラーが発生しました。\n恐れ入りますが、最初からお試しください。');
            this.$router.push('/');
            return;
          }
        }

        // 作成したカードを顧客に紐づけ
        const attachResult = await this.attachPaymentMethod(customerId, paymentMethodId);
        if (attachResult.status !== 200 || attachResult.data.customer?.customer !== customerId) {
          alert('お支払いカードの紐づけに失敗しました。\n再度お試しください。');
          await this.$store.dispatch('user/update', null, { root: true });
          this.$router.push('/');
          return;
        }
        const customerData = { customer: { customer_id: customerId } };
        await this.$store.dispatch('user/subscribe/getCustomer', customerData, { root: true });
        await this.$store.dispatch('user/update', null, { root: true });

        const unsubscribe = this.$store.subscribe(async (mutation) => {
          if (mutation.type === 'user/subscribe/putAllData') {
            unsubscribe(); // 1回限りの監視とする
            await this.updateDefaultCard();
          }
        });

        alert('カード情報の登録が完了しました。');

        // クエリがないURLにreplace
        this.$router.replace({ query: {} });
      } catch (error) {
        console.error('Failed to retrieve SetupIntent:', error);
        alert('支払い方法の認証中にエラーが発生しました。\n再度お試しいただくか、別の支払い方法を登録してください。');
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.btns {
  display: flex;
  justify-content: center;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 128px;
  height: 40px;
  padding: 13px 26px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  border-radius: 20px;
  cursor: pointer;
  appearance: none;
  box-shadow: none;
  transition: all .3s;

  &.primary {
    background-color: rgba(26, 34, 61, 1);
    border: none;
    color: #fff;
    a {
      color: #fff;
    }
    &:hover, &.disabled {
      opacity: .6;
      cursor: default;
    }
  }

  &.secondary {
    border: 1px solid rgba(26, 34, 61, 1);
    color: var(--font-black);
    background-color: #fff;
    &:hover {
      opacity: .4;
    }
  }
}

.credit_card {
  display: flex;
  align-items: center;

  &_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.card_img {
  display: inline-block;
  height: 20px;
  width: calc(20px * 220 / 142);
  background-size: cover;
  border-radius: 2px;
  margin: auto 5px auto 0;
}

.card_No {
  font-size: 18px;
}

.edit_btn {
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  &.address {
    display: inline;
  }
}

.certLabel {
  margin-left: 10px;
  padding: 0 5px;
  border-radius: 4px;
  &.certified {
    border: 1px solid #2a8536;
    background-color: #fff;
    color: #339c41;
  }
  &.uncertified {
    border: 1px solid #8a8d91;
    background-color: #fff;
    color: #8a8d91;
  }
}

@include sm-view {
  .credit_card_wrap {
    display: block;
  }
  .edit_btn {
    width: fit-content;
    margin: 12px 0 0 auto;
  }
}
</style>
